var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 296 296",
    style: {
      enableBackground: "new 0 0 296 296"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M148,0C66.4,0,0,66.4,0,148s66.4,148,148,148s148-66.4,148-148S229.6,0,148,0z M148,280c-36.3,0-69.1-14.7-93-38.4 c-9.5-9.5-17.6-20.4-23.9-32.4C21.4,190.8,16,170,16,148C16,75.2,75.2,16,148,16c34.5,0,66,13.3,89.5,35.1 c12.2,11.3,22.3,24.8,29.6,40c8.3,17.2,12.9,36.5,12.9,56.9C280,220.8,220.8,280,148,280z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4,114.4c8.6,0,15.6,6.6,15.6,15.6h16c0-18-14.2-31.6-31.6-31.6S65.8,112,65.8,130h16C81.8,121,88.8,114.4,97.4,114.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.6,114.4c8.6,0,15.6,6.6,15.6,15.6h16c0-18-14.2-31.6-31.6-31.6S167,112,167,130h16C183,121,190,114.4,198.6,114.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.7,230c31,0,60.6-15.8,77.6-42.1l-13.4-8.7c-15.6,24.1-44.1,37.6-72.7,34.3c-22.3-2.6-42.8-15.4-55.1-34.3l-13.4,8.7 c14.8,22.9,39.7,38.4,66.7,41.5C140.8,229.8,144.3,230,147.7,230z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.82f72fe4b28042b32e46b0709ef97fed.svg";
export { ForwardRef as ReactComponent };